module.exports = __webpack_public_path__ + "public/images/ReferralsProgram_2023.0500a0375226f7313828816c3a5a2013.png";